import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { HubPage } from './pages/HubPage';
import { AboutPage } from './pages/AboutPage';
import { CoachingPage } from './pages/CoachingPage';
import { ContactPage } from './pages/ContactPage';
import { AuthPage } from './pages/AuthPage';
import { ProfilePage } from './pages/ProfilePage';
// Scroll to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-dark-primary text-white flex flex-col font-body selection:bg-accent-blue selection:text-black" data-id="element-2">
        <Navigation data-id="element-3" />
        <div className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HubPage data-id="element-7" />} data-id="element-6" />
            <Route path="/about" element={<AboutPage data-id="element-9" />} data-id="element-8" />
            <Route path="/coaching" element={<CoachingPage data-id="element-11" />} data-id="element-10" />
            <Route path="/contact" element={<ContactPage data-id="element-13" />} data-id="element-12" />
            <Route path="/auth" element={<AuthPage data-id="element-15" />} data-id="element-14" />
            <Route path="/profile" element={<ProfilePage data-id="element-17" />} data-id="element-16" />
          </Routes>
        </div>
        <Footer data-id="element-18" />
      </div>
    </Router>;
}